import ViewMore from "../ManPower/ViewMore";
import ViewMoreEuipment from "./ViewMoreEquipment";



const ExpandableEquipment = ({data,getData, titleId,Activity, selectedExpandedItems, onExpandedCheckboxChange,projectId,Unit,Type }) => {

  
    return (
      <>
      {
          data.map((item, index) => (
              <tr className={`w-[100%] even:bg-white odd:bg-gray-50 text-xs font-normal text-[#71797E]`}  key={index}>
              <td className=" w-[5%] py-3 px-1 text-left">
                  <div className=" w-full gap-1 flex">
                  <input 
              type="checkbox" 
              checked={selectedExpandedItems[titleId]?.includes(item.id) || false}
              onChange={() => onExpandedCheckboxChange(titleId, item.id)}
              />
                  {index+1}
                  </div>
              </td>

              <td className=" w-[35%] py-3 px-1 text-left">{item?.item||"-"}</td>
              <td className=" w-[15%] py-3 px-1 text-left">{item?.unit||"-"}</td>
              <td className=" w-[10%] py-3 px-1 text-left">{item?.type}</td>
              <td className=" w-[10%] py-3 px-1 text-left">{item?.quantity||"-"}</td>
              <td className=" w-[10%] py-3 px-1 text-left">{item?.unitPrice||"-"}</td>
              <td className=" w-[10%] py-3 px-1 text-left">{item?.totalPrice||"-"}</td>
  
              {/* <td className=" w-[10%] py-3 px-1">{<NuAmount value={item?.budget_Price||0}/>}</td>
              <td className=" w-[10%] py-3 px-1">{item?.actual_quantity||"-"}</td>
              <td className=" w-[10%] py-3 px-1">{<NuAmount value={item?.actual_Price||0}/>}</td>
              <td className=" w-[10%] py-3 px-1">{<NuAmount value={item?.amount||0} />}</td> */}
              <td className=" w-[5%] py-3 pl-3">
                           <ViewMoreEuipment
                              id={data.id  || ""}
                              getData={getData}
                              data={item}
                              projectId={projectId}
                              Unit={Unit}
                              Type={Type}
                              Activity={Activity}
                              /> 
                              
              </td>
             </tr>
          ))
      }
      </>
    );
};

export default ExpandableEquipment;
